import React from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  styled,
  Typography,
  Breakpoint,
} from "@mui/material";

const StyledTableContainer = styled(TableContainer)<{
  breakpoint: Breakpoint;
}>(({ theme, breakpoint }) => ({
  border: `1px solid ${theme.palette.border.secondary}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],

  "& tr:last-child td": {
    borderBottom: "none",
  },
  "& td, & th": {
    borderRight: `1px solid ${theme.palette.border.secondary}`,
  },

  "& td:last-child, & th:last-child": {
    borderRight: "none",
  },

  "& td": {
    padding: theme.spacing(5.25, 6),
  },

  [theme.breakpoints.down(breakpoint)]: {
    "& td": {
      padding: theme.spacing(4, 3),
    },
  },
}));

const StyledTableHead = styled(TableHead)<{
  breakpoint: Breakpoint;
}>(({ theme, breakpoint }) => ({
  "& th": {
    backgroundColor: theme.palette.background.subtle,
    padding: theme.spacing(3.75, 6),
  },

  [theme.breakpoints.down(breakpoint)]: {
    "& th": {
      padding: theme.spacing(3.75, 3),
    },
  },
}));

type DataEntry = {
  [key: string]: {
    value: React.ReactNode;
    label?: string;
  };
};

type Props = {
  data: DataEntry[];
  breakpoint?: Breakpoint;
};

export const SimpleTable = ({ data, breakpoint = "sm" }: Props) => {
  if (!data || !data.length) {
    return null;
  }

  return (
    <StyledTableContainer breakpoint={breakpoint}>
      <Table>
        <StyledTableHead breakpoint={breakpoint}>
          {Object.values(data[0]).map((dataItem) => (
            <TableCell key={`header-cell-${dataItem.label}`}>
              <Typography variant="caption2">{dataItem.label}</Typography>
            </TableCell>
          ))}
        </StyledTableHead>
        <TableBody>
          {data.map((dataEntry, index) => {
            return (
              <TableRow key={`row-${index}`}>
                {Object.values(dataEntry).map((dataItem) => (
                  <TableCell key={`row-${index}-cell-${dataItem.label}`}>
                    {dataItem.value}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};
